import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { removeFromCart, clearCart, setCart } from "../../redux/cart/cartActions";
import PaymentOptions from "../PaymentMethods/PaymentMethods";
import Discount from "../Discount/Discount";
import "./Cart.css";
import CryptoJS from "crypto-js";
import Cookies from 'js-cookie';
import axios from 'axios';
import { updateWallet } from "../../components/Service/Transaction";
import Swal from 'sweetalert2';
import PaymentService from "../../components/Service/NeoXService";
import { createPayPal } from "../../components/Service/PaypalService";
import Form from 'react-bootstrap/Form';
import { Pagination } from 'react-bootstrap';
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { publicIpv4 } from "public-ip";
const baseURL = process.env.REACT_APP_API_URL;

const paymentService = new PaymentService();

function App() {
    const navi = useNavigate();

    const token = Cookies.get("Token");

    const dispatch = useDispatch();
    const [ipAddress, setIpAddress] = useState("");


    const cart = useSelector((state) => state.cart.cartItems);
    useEffect(() => {
        const fetchIp = async () => {
            try {
                const ip = await publicIpv4();
                setIpAddress(ip);
            } catch (error) {
                console.error("Lỗi khi lấy IP:", error);
            }
        };
        fetchIp();
    }, []);



    const [selectedItems, setSelectedItems] = useState(cart.map(item => item.id));
    const [isChecked, setIsChecked] = useState(false);
    const [option, setoption] = useState("");
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [option, setOption] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    useLanguage();

    const { t } = useTranslation();
    const handleRowsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
        setRowsPerPage(Number(event.target.value));

    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleRemoveFromCart = (id) => {
        dispatch(removeFromCart(id));
    };

    const handleSelectItem = (id) => {
        if (selectedItems.includes(id)) {
            setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
        } else {
            setSelectedItems([...selectedItems, id]);
        }
    };

    const [totalAmount, setTotalAmount] = useState(0);
    const [Subtotal, setSubtotal] = useState(0);
    const [tax, setTax] = useState(0);
    const calculateAmounts = () => {
        return cart.reduce(
            (acc, item) => {
                if (selectedItems.includes(item.id)) {
                    acc.subtotal += item.total;
                    acc.total += item.total * 1.1;
                    acc.taxt += item.total * 0.1;
                }
                return acc;
            },
            { subtotal: 0, total: 0, taxt: 0 }
        );
    };

    useEffect(() => {
        const { subtotal, total, taxt } = calculateAmounts();
        setSubtotal(subtotal);
        setTotalAmount(total);
        setTax(taxt)
    }, [selectedItems, cart]);

    // console.log("totalAmount", totalAmount)
    // console.log("Subtotal", Subtotal)
    // console.log("tax", tax)



    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cart.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(cart.length / itemsPerPage);

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const [accessToken, setAccessToken] = useState("");

    const [systemName, setsystemName] = useState("");
    const createTransaction = async (invoiceID, totalAmount, gatewayId, paymentMethod, status = 0) => {
        try {
            const response = await fetch(`${baseURL}/api/v1/create-transaction`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    status,
                    invoiceId: invoiceID,
                    amount: totalAmount,
                    gatewayId,
                    type: 1,
                    paymentMethod
                }),
            });

            if (!response.ok) throw new Error("Failed to create transaction.");
            return await response.json();
        } catch (error) {
            console.error("Error creating transaction:", error);
        }
    };
    const handlePayment = async () => {
        try {
            setLoading(true);

            const selectedCartItems = cart.filter(item => selectedItems.includes(item.id));
            if (selectedCartItems.length > 0) {
                setsystemName(selectedCartItems[0]?.system_name || "");
            }

            const cartData = selectedCartItems.map(item => ({
                id: item.id,
                name: item.name,
                quantity: item.quantity,
                price: item.price,
                cycle: item.cycle,
                region_id: item.region_id,
                package_id: item.package_id,
                image_id: item.image_id,
                backup_id: item.backup_id || 0,
                system_id: item.system_id,
                tax_id: item?.tax_id,
                hostname: item?.hostname,
                total: item?.total
            }));

            const orderDetails = cartData.map(item => ({
                start_date: new Date().toISOString().split('T')[0],
                periods: item.cycle,
                status: 1,
                region_id: item.region_id,
                package_id: item.package_id,
                image_id: item.image_id,
                backup_id: item.backup_id || 0,
                system_id: item.system_id,
                tax_id: item.tax_id,
                ssh_key_id: 1,
                domain_hosting_name: item?.hostname,
                sub_total: item?.total,
            }));

            const invoiceitems = cartData?.map(item => ({
                sub_total: item?.total,
                taxed: item?.tax_id,
                payment_method: option,
                des: "",
                notes: "",
                package_id: item.package_id,
            }));

            const orderData = {
                promo_code: "N/A",
                promo_value: "0",
                note: "",
                amount: Subtotal,
                sub_total: Subtotal || 1000,
                tax: tax,
                total: totalAmount,
                payment_method: option,
                credit: "0",
                tax_rate: 10,
                paid_date: "",
                status: 0,
                ip_address: ipAddress,
                invoice_items: invoiceitems,
                order_details: orderDetails
            };

            const response = await fetch(`${baseURL}/api/v1/create-order-test`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(orderData)
            });

            if (!response.ok) {
                throw new Error("Failed to create order.");
            }

            const data = await response.json();
            console.log("Thanh toán thành công:", data);

            const remainingCartItems = cart.filter(item => !selectedItems.includes(item.id));
            localStorage.setItem("cartItems", JSON.stringify(remainingCartItems));
            dispatch(setCart(remainingCartItems));
            setSelectedItems([]);
            localStorage.setItem("chosenCategory", systemName);

            const invoiceID = data?.invoice?.id;
            const invoiceName = data?.invoice?.name;
            const order_detailsID = data?.order?.id;
            const order_detailsIDNeo = String(data?.order?.id);
            Cookies.set("invoiceID", invoiceID, { expires: 1 });

            const updateTransaction = async (paymentMethod, gatewayId) => {
                try {
                    const transactionResponse = await fetch(`${baseURL}/api/v1/create-transaction`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            status: 0,
                            invoiceId: invoiceID,
                            amount: totalAmount,
                            gatewayId: gatewayId,
                            type: 1,
                            paymentMethod: paymentMethod
                        }),
                    });

                    if (!transactionResponse.ok) {
                        throw new Error(`Failed to create transaction for ${paymentMethod}`);
                    }

                } catch (error) {
                    console.error(`Error updating wallet for ${paymentMethod}:`, error);
                }
            };

            // Xử lý các phương thức thanh toán
            if (option === "paypal") {
                await updateTransaction("Paypal", 2);
                const approvalUrl = await createPayPal(invoiceID, totalAmount, "Tạo VM", order_detailsID, 1, "");
                const url = new URL(approvalUrl);
                url.searchParams.set("payment_method", "paypal");
                window.location.href = url.toString();
            }
            else if (option === "napas") {
                await updateTransaction("ATM", 1);
                const paymentUrl = await paymentService.createPayment(totalAmount, invoiceID, "ATM", "createvm", order_detailsIDNeo, 1);
                if (paymentUrl) {
                    const url = new URL(paymentUrl);
                    url.searchParams.set("payment_method", "ATM");
                    window.location.href = url.toString();
                }
            }
            else if (option === "visa") {
                await updateTransaction("Credit Card", 1);
                const paymentUrl = await paymentService.createPayment(totalAmount, invoiceID, "CC", "createvm", order_detailsIDNeo, 1);
                if (paymentUrl) {
                    const url = new URL(paymentUrl);
                    url.searchParams.set("payment_method", "Credit Card");
                    window.location.href = url.toString();
                }
            }
            else if (option === "qr") {
                await updateTransaction("QR", 1);
                const paymentUrl = await paymentService.createPayment(totalAmount, invoiceID, "QR", "createvm", order_detailsIDNeo, 1);
                if (paymentUrl) {
                    const url = new URL(paymentUrl);
                    url.searchParams.set("payment_method", "QR");
                    window.location.href = url.toString();
                }
            }
            else if (option === "bank") {
                await updateTransaction("Bank transfer", 4);
                navi('/thank-you/bank', { state: { invoiceID } });
            }
            else if (option === "wallet") {
                await updateWallet(totalAmount);
                await updateTransaction("Wallet", 3);
                const paymentResponse = await fetch(`${baseURL}/api/v1/update-payment`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        status: "COMPLETED",
                        invoiceId: invoiceID,
                        paymentMethod: "wallet"
                    }),
                });

                if (!paymentResponse.ok) throw new Error("Failed to update payment.");
                const paymentResult = await paymentResponse.json();
                console.log("Payment updated successfully", paymentResult);
                window.location.href = '/thank-you/bank';
            }

        } catch (error) {
            console.error("Payment failed:", error);
        } finally {
            setLoading(false);  // Đảm bảo setLoading false khi hoàn tất
        }
    };



    const handleOnSelectedOption = (item) => {
        setoption(item)
    }


    const handleSelectAll = () => {
        if (isAllSelected) {
            setSelectedItems([]);
        } else {
            setSelectedItems(cart.map(item => item.id));
        }
        setIsAllSelected(!isAllSelected);
    };
    useEffect(() => {
        setIsAllSelected(selectedItems.length === cart.length && cart.length > 0);
    }, [selectedItems, cart]);



    return (
        <div className="cart-container">

            {
                loading && (
                    <div className="spinner-overlay">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
            <div
                className="container-fluid"

            >
                <div
                    className="row justify-content-between"

                >
                    <div className="col-12 col-md-8 mb-4 mb-md-0">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <span>
                                {cart.length} {t("Records Found")}, {t("Showing")} {indexOfFirstItem + 1} {t("to")} {Math.min(indexOfLastItem, cart.length)}
                            </span>

                            <Form.Select
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                style={{ width: '150px' }}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </Form.Select>
                        </div>

                        <h2 className="cart-title">{t("Service Cart")}</h2>
                        <div
                            className="table-responsive"

                        >
                            <table className="cart-table">
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                checked={isAllSelected}
                                                onChange={handleSelectAll}
                                            />
                                        </th>
                                        <th>{t("Products/Services")}</th>
                                        <th>{t("Hostname")}</th>
                                        <th>{t("Cycle/month")}</th>
                                        <th>{t("Subtotal")}</th>
                                        <th>{t("Tax")}</th>
                                        <th>{t("Amout")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedItems.includes(item.id)}
                                                    onChange={() => handleSelectItem(item.id)}
                                                />
                                            </td>
                                            <td>
                                                <strong>{item.name}</strong><br />
                                                <small>{item.service}</small>
                                                <p style={{ padding: "0", margin: "0" }}>
                                                    <small>
                                                        {item.nameversion?.systemName} {item.nameversion?.version}
                                                    </small>
                                                </p>
                                            </td>
                                            <td>{item.hostname}</td>
                                            <td>{item.cycle}</td>
                                            <td>{item?.total?.toLocaleString("vi-VN") || "0"}</td>
                                            <td>{(item?.total * 0.1).toLocaleString("vi-VN")}</td>
                                            <td>{((item?.total * 0.1) + item?.total).toLocaleString("vi-VN")}</td>
                                            <td>
                                                <button
                                                    className="delete-button"
                                                    onClick={() => handleRemoveFromCart(item.id)}
                                                >
                                                    {t("Delete")}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "right", fontWeight: "bold" }}>{t("Total Amount")}</td>
                                        <td colSpan="1" style={{ fontWeight: "bold", color: "#0069ff" }}>
                                            {totalAmount.toLocaleString("vi-VN")}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div style={{ width: "30%" }} className="col-12 col-md-4">
                        <div className="total-amount">
                            <h4>{t("Choose Payment")}</h4>
                            <PaymentOptions
                                totalAmount={totalAmount}
                                OnSelectedOption={setoption}
                            />
                        </div>

                        <div className="mt-3 mb-3 d-flex align-items-center">
                            <input
                                type="checkbox"
                                id="terms"
                                className="me-2"
                                onChange={() => setIsChecked(!isChecked)}
                                checked={isChecked}
                            />
                            <label htmlFor="terms" style={{ margin: 0 }}>
                                Tôi đồng ý với{" "}
                                <a
                                    style={{ textDecoration: "none" }}
                                    href="https://www.tidadigi.com/dieu-khoan-su-dung-dich-vu"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Thỏa thuận sử dụng
                                </a>{" "}
                                và{" "}
                                <a
                                    style={{ textDecoration: "none" }}
                                    href="https://www.tidadigi.com/chinh-sach-bao-mat"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Chính sách bảo mật
                                </a>{" "}
                                của TIDADIGI.
                            </label>
                        </div>

                        <button
                            style={{ width: "100%" }}
                            className="btn btn-primary"
                            disabled={!isChecked || selectedItems.length === 0 || cart.length === 0}
                            onClick={handlePayment}
                        >
                            {t("Make a Payment")}
                        </button>
                    </div>
                </div>

                <div
                    className="d-flex justify-content-center"
                // style={{
                //     position: 'sticky',
                //     bottom: '0',
                //     backgroundColor: 'white',
                //     zIndex: 1000,
                //     display: 'flex',
                //     justifyContent: 'center',
                //     padding: '10px 0',
                //     boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)', 
                // }}
                >
                    <Pagination>
                        <Pagination.Prev
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            {t("Previous")}
                        </Pagination.Prev>

                        {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}

                        <Pagination.Next
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            {t("Next")}
                        </Pagination.Next>
                    </Pagination>
                </div>
            </div>

        </div >



    );
}

export default App;
